var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-card-title',{staticClass:"mb-sm-0 mb-1"},[_vm._v(" Statistics ")])],1),_c('b-card-body',[_c('vue-apex-charts',{attrs:{"type":"radialBar","height":"400","options":_vm.apexChatData.radialBarChart.chartOptions,"series":_vm.apexChatData.radialBarChart.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }